import { toast } from "sonner";
import { WorkingSetBar } from "@/components/ai-chat-ui";
import { useWs } from "@/workspace/context";
import { keepChanges, undoChanges, useWorkingFiles, type AiSource } from "./ai-changes";

/**
 * "N arquivos alterados · Revisar · Aprovar · Desfazer" do agente e do Claude: o que a IA mudou no
 * projeto, com o diff de cada arquivo (mesmo controle do chat do Copilot).
 */
export function AiWorkingSet({ source }: { source: AiSource }) {
  const ws = useWs();
  const projectId = ws.detail.project.id;
  const files = useWorkingFiles(projectId, source);
  if (!files.length) return null;
  return (
    <div className="pt-1.5">
      <WorkingSetBar
        files={files}
        onKeep={(path) => keepChanges(projectId, source, path)}
        onUndo={(path) =>
          void undoChanges(ws.session, projectId, source, path)
            .then((n) =>
              toast.success(
                path
                  ? `${path.split("/").pop()} voltou como estava.`
                  : `${n} ${n === 1 ? "arquivo voltou" : "arquivos voltaram"} como estavam.`,
              ),
            )
            .catch((err: unknown) =>
              toast.error(err instanceof Error ? err.message : "Não deu para desfazer agora."),
            )
        }
      />
    </div>
  );
}
